import { Role } from "../../enums/user";
import { User } from "../../store/auth";
import {
  DefaultFetchError,
  FetchGet,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchGet,
  useFetchUpdate,
} from "../fetch";

export interface LoggerUserState {
  email: string;
  id: string;
  role: Role;
}

export interface Logger {
  id: string;
  event: string;
  entity: string;
  action: string;
  entityId: string;
  description?: string;
  data: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
  user: User | null;
  before?: LoggerUserState;
  after?: LoggerUserState;
}

export interface LoggerTableRow extends Logger {
  key: string;
}

export interface LoggerTableData {
  data: LoggerTableRow[];
  total: number;
}

export interface LoggerGetParams
  extends PagingParams, Partial<Omit<Logger, "id" | "user" | "data">> {
  orderByColumn?: keyof Omit<Logger, "id" | "user" | "data">;
}

export const useLoggersGet = <DD = PagingDataResponse<Logger>>(
  decorateData?: (data: PagingDataResponse<Logger>) => DD,
): FetchGet<
  PagingDataResponse<Logger>,
  LoggerGetParams,
  DefaultFetchError,
  DD
> =>
  useFetchGet("loggers", {
    autoStart: false,
    startStateLoading: false,
    decorateData,
    config: {
      params: {
        orderBy: "ASC",
        orderByColumn: "createdAt",
      },
    },
  });

export const useLoggerTableGet = () =>
  useLoggersGet<LoggerTableData>(
    ({ data, meta }: PagingDataResponse<Logger>): LoggerTableData => ({
      data: data.map((item) => ({
        key: item.id,
        ...item,
      })),
      total: meta.itemCount,
    }),
  );
